import { getSdk } from "./sdkService";
import { config } from "../config/config";
import { getAppState } from "../state/index";
import * as Sentry from "@sentry/browser";

/**
 * Checks if there is some choice -saved on localStorage (in case it's available)- made by the user
 * to determine if she/he wants voucher related screens to be showed or not.
 * @param {Boolean} isLocalStorageDependant - Value that determines if localStorage is needed to be checked.
 * @returns {Boolean} Value that determines if voucher related screens/flows shall be shown or not.
 * @private
 */
function checkLocalStorageDependency(isLocalStorageDependant) {
  const isShowingEnabled =
    (localStorage && localStorage.getItem("showVoucherPopup") === null && true) ||
    JSON.parse(localStorage.getItem("showVoucherPopup"));
  return isLocalStorageDependant ? isShowingEnabled : true;
}

/**
 * Checks device eVoucher eligibility and returns voucher data in case it exists and eVoucher
 * functionality is active from config file. If not, returns false.
 * @returns {Object|Boolean} - Voucher data object or false in case there is no object voucher data retrieved.
 * @public
 */
export async function checkVoucherEligiblity(isLocalStorageDependant = true) {
  try {
    if (config.get().featureToggles.eVoucher) {
      const isShowingEnabled = checkLocalStorageDependency(isLocalStorageDependant);
      const voucherEligibility = await getSdk().userManager.checkVoucherEligiblity();

      if (isShowingEnabled === true && voucherEligibility && voucherEligibility.redeemed === false) {
        getAppState().voucherData = voucherEligibility;
        return voucherEligibility;
      }
      return false;
    }
    return false;
  } catch (e) {
    Sentry.captureException(e);
    return false;
  }
}

export async function checkEvoucherEligiblity(country, duration) {
  try {
    const voucherEligibility = await getSdk().userManager.checkEvoucherEligiblity(country, duration);
    return voucherEligibility;
  } catch (e) {
    Sentry.captureException(e);
    throw e;
  }
}

export async function checkYearEligibility() {
  try {
    const eligibleYears = await getSdk().userManager.checkEvoucherDeviceValidity();
    return eligibleYears;
  } catch (e) {
    throw e;
  }
}

export async function checkAlreadyRedeemed() {
  try {
    await getSdk().userManager.checkEvoucherValidation();
    return true;
  } catch (e) {
    return false;
  }
}

export async function eVoucherProvisioning(baseVoucherCode, addonVoucherCode) {
  try {
    const voucherEligibility = await getSdk().userManager.eVoucherProvision(baseVoucherCode, addonVoucherCode);
    const updatedUser = await getSdk().userManager.get();
    return {
      ...voucherEligibility,
      ...updatedUser
    };
  } catch (e) {
    Sentry.captureException(e);
    e.customCode = "ProvisioningError";
    throw e;
  }
}
